import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function RecommendedSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const featured = mangaList.slice(0, 6);
  const visibleCount = 4;

  const nextSlide = () => {
    setCurrentIndex(prev =>
      prev + visibleCount >= featured.length ? 0 : prev + visibleCount
    );
  };

  const prevSlide = () => {
    setCurrentIndex(prev =>
      prev - visibleCount < 0 ? Math.max(0, featured.length - visibleCount) : prev - visibleCount
    );
  };

  const visibleManga = featured.slice(currentIndex, currentIndex + visibleCount);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              编辑推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              精心挑选的高品质韩国漫画，每一部都值得细细品味
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={prevSlide}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="上一个"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={nextSlide}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="下一个"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {visibleManga.map(manga => (
            <Link
              key={manga.id}
              to={`/manga/${manga.slug}`}
              className="group no-underline"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-100">
                <img
                  src={manga.coverImage}
                  alt={`${manga.title} - 韩漫之家韩国漫画`}
                  title={`${manga.title} - 好看的韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-md">
                    {manga.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-xs text-white/90">{manga.category}</span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          {Array.from({ length: Math.ceil(featured.length / visibleCount) }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i * visibleCount)}
              className={`w-2 h-2 rounded-full mx-1 transition-all duration-300 cursor-pointer ${
                i === Math.floor(currentIndex / visibleCount)
                  ? 'bg-primary-500 w-6'
                  : 'bg-background-300 hover:bg-background-400'
              }`}
              aria-label={`第${i + 1}页`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}